import { Globe, MessageCircle, Phone, Bell } from "lucide-react";
import { SectionHeading } from "../common/SectionHeading";
import { ScannerPhone } from "./ScannerPhone";

const CHANNELS = [
  { icon: Bell, label: "Website notifications" },
  { icon: MessageCircle, label: "WhatsApp" },
  { icon: Phone, label: "SMS & automated voice" },
  { icon: Globe, label: "Works in any mobile browser" },
];

export const ScannerDemoSection = () => (
  <section className="section-pad">
    <div className="container-x grid items-center gap-14 lg:grid-cols-[1fr_auto]">
      <div>
        <SectionHeading
          label="Scanner preview"
          title="What someone sees when they scan."
          body="No download, no sign-up. The scan opens a simple page in the phone's browser where they choose why they need you. Tap through the preview to explore it."
        />
        <span data-testid="demo-prototype-badge" className="label-mono mt-8 inline-flex rounded-md border border-[#FF5500]/40 bg-[#FF5500]/10 px-3 py-1.5 text-[#FF5500]">
          UI prototype · alerts are not live yet
        </span>
        <div className="mt-10">
          <p className="label-mono text-slate-500">Planned delivery channels</p>
          <ul className="mt-4 grid gap-3 sm:grid-cols-2">
            {CHANNELS.map(({ icon: I, label }) => (
              <li key={label} className="flex items-center gap-3 rounded-lg border border-white/10 bg-[#0F111A] px-4 py-3 text-sm text-slate-300">
                <I className="h-4 w-4 text-slate-400" aria-hidden="true" /> {label}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <ScannerPhone />
    </div>
  </section>
);
